module.exports = __webpack_public_path__ + "02_medium_brown.8e32ce38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_medium_brown.png
// module id = PFvD
// module chunks = 0